import React from 'react';

import { TemplateSwitch } from 'src/templates';

import { marketingCmsClient } from 'src/lib/contentful-client';
import { ContentfulTemplates } from 'src/lib/constants';
import { optimizeContentfulImages } from 'src/lib/image-helpers';

const ProductPage = (props) => {
  return <TemplateSwitch {...props} />;
};

// Static build: uses getStaticPaths to pre-generate all product pages at build time
export async function getStaticPaths() {
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/entries
  const entries = await marketingCmsClient.getEntries({
    content_type: ContentfulTemplates.PRODUCT_PAGE,
    'fields.locale': 'US',
  });

  const paths = entries.items
    .map((entry) => {
      if (entry.fields.pageSlug && entry.fields.locale) {
        return { params: { index: entry.fields.pageSlug } };
      }
      return null;
    })
    .filter((entry) => {
      return !!entry;
    });

  return {
    paths,
    fallback: false,
  };
}

// https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
export async function getStaticProps({ params, preview }) {
  const { index: slug } = params;
  // https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/entries
  const legacyTemplateRequest = marketingCmsClient.getEntries({
    content_type: ContentfulTemplates.PRODUCT_PAGE,
    include: 10,
    'fields.locale': 'US',
    'fields.pageSlug': slug,
    order: ['sys.createdAt'], // To ensure the first entry in the array is the first one created with this slug
  });

  const newTemplateRequest = marketingCmsClient.getEntries({
    content_type: ContentfulTemplates.PAGE,
    include: 10,
    limit: 1000,
    'fields.url[in]': [slug],
    locale: 'en-US',
  });

  const [legacyEntry, newEntry] = await Promise.all([
    legacyTemplateRequest,
    newTemplateRequest,
  ]);

  const matchingNewEntry = newEntry?.items?.find((entry) => {
    const url = entry?.fields?.url;
    if (url.length === 2) {
      return url[0] === 'products' && url[1] === slug;
    }
    return false;
  });

  const entry = legacyEntry?.items?.[0] || matchingNewEntry;

  return { props: { ...optimizeContentfulImages(entry), preview: !!preview } };
}

export default ProductPage;
